<template>
  <div class="funnel-list-container">
    <DataTable
      v-if="parsedFunnels.length > 0"
      :value="parsedFunnels"
      class="p-datatable-sm"
      responsive-layout="scroll"
      striped-rows
    >
      <Column
        field="name"
        :header="t('templates.name')"
      />
      <Column
        field="labelType"
        :header="t('templates.type')"
      />
      <Column
        :header="t('templates.actions')"
        style="width: 100px"
      >
        <template #body="slotProps">
          <div class="flex justify-content-center">
            <Button
              icon="fa-regular fa-pen-to-square"
              class="p-button-text p-button-secondary p-button-rounded p-button-sm"
              :label="t('templates.edit')"
              @click="editFunnel(slotProps.data.id, slotProps.data.name, slotProps.data.type)"
            />
          </div>
        </template>
      </Column>
    </DataTable>
    <div
      v-else
      class="p-2"
    >
      {{ t('templates.funnels.noFunnelsAvailable') }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';

interface Funnel {
  id: string | number;
  name: string;
  type: string;
}

export default defineComponent({
  name: 'FunnelsList',

  components: {
    DataTable,
    Column,
    Button,
  },

  props: {
    templateConfig: {
      type: String,
      required: true,
    },
  },

  emits: ['edit-funnel'],

  setup(props, { emit }) {
    const { t } = useI18n();

    const parsedFunnels = computed<Funnel[]>(() => {
      try {
        const config = JSON.parse(props.templateConfig);
        if (config && config.funnels && Array.isArray(config.funnels)) {
          return config.funnels.map((funnel: Funnel) => ({
            id: funnel.id,
            name: funnel.name,
            type: funnel.type,
            labelType: t(`templates.channels.${funnel.type}`),
          }));
        }
      } catch (e) {
        console.error('Error parsing template_config JSON:', e);
      }
      return [];
    });

    const editFunnel = (templateId: number, name: string, type: string) => {
      emit('edit-funnel', templateId, name, type);
    };

    return {
      parsedFunnels,
      t,
      editFunnel,
    };
  },
});
</script>

<style scoped>
.funnel-list-container {
  padding: 1rem;
}
</style>
